import { getSettings, updateSettings } from "../../api/setting";
import { log2 } from "../../utils/log2";
import _ from "lodash";

const defaultPreferredThemeColor = "servquick";
const log = log2("settings.vuex");
const setting = {
    namespaced: true,
    state: {
        allThemeColors: [
            "black",
            "gray",
            "yellow",
            "orange",
            "red",
            "green",
            "pink",
            "purple",
            "blue",
            "mango",
            "servquick",
        ],
        settings: {
            language: {},
            chatCustomizationSettings: {
                preferredThemeColor: defaultPreferredThemeColor,
            },
            customLoginFormEnabled: false,
            initialized: true,
        },

        initialized: false,
        offlineMode: false,
    },
    getters: {
        whatsappEnabled: (state) => _.get(state.settings, "whatsapp.enabled", false),
    },
    mutations: {
        SET_SETTINGS: (state, payload) => {
            log.debug("SET_SETTINGS", payload);

            state.settings = payload;
            state.initialized = true;
        },
        SET_SETTING_VALUE: (state, payload) => {
            log.debug("SET_SETTING_VALUE", payload);
            _.set(state.settings, payload.setting, payload.value);

            return state.settings;
        },
        OFFLINE_MODE_UPDATED: (state, payload) => {
            //log.debug("OFFLINE_MODE_UPDATED", payload)
            state.offlineMode = payload;
        },
    },
    actions: {
        getSettings({ commit }) {
            return getSettings().then((response) => {
                let settings = {
                    language: {},
                };
                if (response.data.length > 0) {
                    settings = response.data[0];
                }
                if (settings.language == null) {
                    settings.language = {};
                }
                commit("SET_SETTINGS", settings);
                return response;
            });
        },
        updateSettings({ state }, newSettings) {
            log("updateSettings called", newSettings);
            return updateSettings(newSettings);
        },

        setSettingValue({ commit, state }, payload) {
            payload = Array.isArray(payload) ? payload : [payload];
            payload.forEach((x) => {
                commit("SET_SETTING_VALUE", x);
            });
            return Promise.resolve(state.settings);
        },
        setSettings({ commit }, payload) {
            commit("SET_SETTINGS", payload.settings);
        },
        offlineModeUpdated({ commit }, payload) {
            commit("OFFLINE_MODE_UPDATED", payload.offlineMode);
        },
    },
};

export default setting;
